import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/Layout.vue'
import Home from '../views/home/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
        meta: { navbarMode: 'transparent', menuKey: 'Home' }
      },
      {
        path: 'about',
        name: 'About',
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        meta: { navbarMode: 'solid', menuKey: 'About' }
      },
      {
        path: 'cultural-mall',
        name: 'CulturalMall',
        component: () => import(/* webpackChunkName: "cultural-mall" */ '../views/CulturalMall/index.vue'),
        meta: { navbarMode: 'solid', menuKey: 'CulturalMall',title: '南方文化商城' }
      },
      {
        path: 'art-trade',
        name: 'ArtTrade',
        component: () => import(/* webpackChunkName: "art-trade" */ '../views/ArtTrade/index.vue'),
        meta: { navbarMode: 'solid', menuKey: 'ArtTrade', title: '艺术品交易平台' }
      },
      {
        path: 'gift',
        name: 'Gift',
        component: () => import(/* webpackChunkName: "gift" */ '../views/Gift/index.vue'),
        meta: { navbarMode: 'solid', menuKey: 'Gift', title: '广东礼物' }
      },
      {
        path: 'gift/:id',
        name: 'GiftDetail',
        component: () => import(/* webpackChunkName: "gift-detail" */ '../views/Gift/giftDetail.vue'),
        meta: { navbarMode: 'solid', menuKey: 'Gift', title: '礼物详情' }
      },
      {
        path: 'heritage',
        name: 'Heritage',
        component: () => import(/* webpackChunkName: "heritage" */ '../views/Heritage/index.vue'),
        meta: { navbarMode: 'solid', menuKey: 'Heritage', title: '数遗光年' }
      },
      {
        path: 'exhibitor',
        name: 'Exhibitor',
        component: () => import(/* webpackChunkName: "exhibitor" */ '../views/home/exhibitor.vue'),
        meta: { navbarMode: 'solid', menuKey: "Home",title: '展商列表' }
      },
      {
        path: 'integration',
        name: 'Integration',
        component: () => import(/* webpackChunkName: "integration" */ '../views/home/Integration.vue'),
        meta: { navbarMode: 'solid', menuKey: 'Home', title: '数实融合平台' }
      },
      {
        path: 'good-shop',
        name: 'GoodShop',
        component: () => import(/* webpackChunkName: "good-shop" */ '../views/home/goodShop.vue'),
        meta: { navbarMode: 'solid', menuKey: 'Home', title: '广货行天下品牌馆' }
      },
      {
        path: 'section/:type',
        name: 'SectionPage',
        component: () => import(/* webpackChunkName: "section" */ '../views/sectionPage/index.vue'),
        meta: { navbarMode: 'solid',menuKey: "Home", title: '展会活动' }
      }
    ]
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
